import { transactionDateStore } from "hooks";

export const freeCreditsReportFilterState = (venue) => {
  const { venueId, startDate, endDate } = transactionDateStore(venue);
  return {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
    dateRange: [startDate, endDate],
    locations: [],
    transactionType: null,
  };
};
